import axiosInstance from "./AxiosInstance";

export const postBucketFileApi = (postData) => axiosInstance.post("sla_config/upload", postData);

export const getBucketListApi = () => axiosInstance.get("sla_config/files");

export const deleteBucketFileApi = (body) => axiosInstance.delete("sla_config/delete",  {data: body});
